import { _ } from "core-js";
import session from "./session";

export default {
  fetchTelcoModems() {
    return session.get(`/pricing/charges-and-credits/?product_kind=telco&available=true&category__in=router,modem_delivery`);
  },
  loadProducts(accountId) {
    return session.get(`/accounts/${accountId}/products/`);
  },
  getStatusHistory({ p_id, options }) {
    return session.get(`/products/${p_id}/history/?page=${options.page}&limit=${options.itemsPerPage}&order=desc`);
  },
  getNumbers(p_id) {
    return session.get(`/voip/sites/${p_id}/numbers/`);
  },
  getProductChildren(p_id) {
    return session.get(`/products/${p_id}/children/?include_cost=true`);
  },
  getProductById(p_id) {
    return session.get(`/products/${p_id}/?include_cost=true`);
  },
  getCurrentVoipSite(p_id) {
    return session.get(`/voip/sites/${p_id}/`);
  },
  getAllAddons(kind, version, available, supplier) {
    let availableQuery = `&available=true`;
    return session.get(`pricing/addons/?product_kind__in=${kind.join(",")}&tariff_version=${version}${available?availableQuery : ''}&supplier=${supplier}`);
  },
  getAllTariffs(version,kind,supplier) {
    let kindStr = (kind)?`&product_kind=${kind}`:``;
    return session.get(`/pricing/tariffs/?tariff_version=${version}${kindStr}&supplier=${supplier}`);
  },
  getPromosForTariff(t_id) {
    return session.get(`/pricing/tariffs/${t_id}/promos/`);
  },
  getEnterpriseConfiguration(id) {
    return session.get(`/voip/sites/${id}/configuration/`);
  },
  updateEnterpriseConfiguration(id, data) {
    return session.patch(`/voip/sites/${id}/configuration/`, JSON.stringify(data));
  },
  createProductChildren(id, data) {
    return session.post(`/products/${id}/children/`,JSON.stringify(data));
  },
  updateProduct(p_id,data) {
    return session.patch(`/products/${p_id}/?include_cost=true`,JSON.stringify(data));
  },
  updateChildProductNumber(p_id,number) {
    return session.patch(`voip/seats/${p_id}/`,JSON.stringify({number_id: number}));
  },
  updateSiteNumber(p_id,number) {
    return session.patch(`/voip/sites/${p_id}/`,JSON.stringify({pilot_number_id: number}));
  },
  updateSiteTariff(p_id,tariff) {
    return session.patch(`/products/${p_id}/`,JSON.stringify({tariff_id: tariff}));
  },
  updateSiteContractLength(p_id,contractLength) {
    return session.patch(`/products/${p_id}/`,JSON.stringify({contract_length_months: contractLength}));
  },
  updateSitePromo(p_id,promo) {
    return session.patch(`/products/${p_id}/`,JSON.stringify({promo_id: promo}));
  },
  updateAddons(p_id,addons) {
    return session.patch(`/products/${p_id}/`, JSON.stringify({addons: addons}));
  },
  updateTrialPeriod(p_id,period) {
    return session.patch(`/products/${p_id}/`, JSON.stringify({trial_period_length_days: period}));
  },
  updateInstallAddress(p_id,payload) {
    return session.patch(`/voip/sites/${p_id}/`,JSON.stringify({installation_address: payload}));
  },
  voidProduct({p_id, payload}) {
    return session.post(`/products/${p_id}/actions/transition/`, payload);
  },
  lostProduct({p_id, payload}) {
    return session.post(`/products/${p_id}/actions/transition/`, payload);
  },
  loadLinkedProduct(lead_id) {
    return session.get(`/products/${lead_id}/links/all/`)
  },
  loadProductsEscalation(p_id) {
    return session.get(`/products/${p_id}/tickets/?status__in=escalation,open,pending,new`);
  },
  createLinkedProduct(lead_id, payload) {
    return session.post(`/products/${lead_id}/links/`, payload);
  },
  changeTariff(p_id,payload) {
    return session.patch(`/products/${p_id}/actions/change-tariff/`,JSON.stringify(payload));
  },
  loadProductNotes(productId) {
    return session.get(`/products/${productId}/notes/`);
  },
  createProductNote(productId, data) {
    return session.post(`/products/${productId}/notes/`,JSON.stringify({ ...data }));
  },
  fetchNoteTemplates() {
    return session.get(`/notes/templates/`);
  },
  deleteProductChild(childId) {
    return session.delete(`/products/${childId}/`);
  },
  loadAllProducts(options) {
    return session.get(`/products/search/?sort=${options.multiSort.join(",")}&page=${options.paginationPage}&limit=${options.paginationLimit}&tariff__in=${options.tariff.join(",")}&product_kind__in=${options.kind.join(",")}&status__in=${options.status.join(",")}&status_reason__in=${options.statusReason.join(",")}&upgrade_status__in=${options.upgradeStatus.join(",")}&tariff_version__in=${options.version.join(",")}&supplier=${options.supplier}&contract_end_date__lt=${options.outOfContract}&promo_end_date__lt=${options.outOfPromo}&migration_hardware=${options.hardware}&migration_headset=${options.headset}&migration_own_phone_setup=${options.ownPhoneSetup}&migration_ipex${options.ipex}&migration_call_recording=${options.callRecording}&migration_international=${options.international}&migration_audio=${options.audio}&migration_non_geo=${options.nonGeo}&migration_crm_connect=${options.crmConnect}&migration_phone_delivery=${options.phoneDelivery}&migration_number_port=${options.numberPort}`);
  },
  loadAvailableHardware(params) {
    return session.get('/voip/available-hardware/', {params});
  },
  loadProductHardware(productId) {
    return session.get(`/voip/sites/${productId}/own-hardware/`);
  },
  updateProductHardware(productId, data) {
    return session.post(`/voip/sites/${productId}/own-hardware/`, data);
  },
  loadProductStatuses(productId) {
    return session.get(`/products/${productId}/transitions/`);
  },
  updateProductStatuses(data) {
    return session.post(`/products/${data.productId}/actions/transition/`,JSON.stringify(data.status));
  },
  createProduct(accountId, data) {
    return session.post(`/accounts/${accountId}/products/`,JSON.stringify(data));
  },
  loadTelcoLines(productId) {
    return session.get(`/telco/lines/${productId}/`);
  },
  replaceModem(productId,data) {
    return session.post(`/telco/lines/${productId}/actions/replace-modem/`, JSON.stringify(data));
  },
  sendEDBEmail(productId) {
    return session.post(`/telco/lines/${productId}/actions/send-edb-email/`);
  },
  fetchRetentionProducts(productId, status) {
    return session.get(`/products/${productId}/retention/?status__in=${status.join(",")}`);
  },
  fetchProductAudit(productId, config) {
    return session.get(`/products/${productId}/audit/?order=desc&page=${config.paginationPage}&limit=${config.paginationLimit}`);
  },

  searchAccounts(search) {
    return session.get(`/accounts/search/?querystring=${encodeURIComponent(search)}`);
  },
  moveToNewAccount(productId) {
    return session.post(`/products/${productId}/actions/new-billing-account/`);
  },
  moveToAnotherAccount(productId,accountId) {
    return session.post(`/leads/${productId}/actions/attach-to-account/${accountId}/`);
  },
  updateSupplier(product_id, supplier) {
    return session.patch(`/products/${product_id}/`, JSON.stringify({supplier}));
  }
};


